import { render, staticRenderFns } from "./QnImage.vue?vue&type=template&id=1ebe506a&scoped=true"
import script from "./QnImage.vue?vue&type=script&lang=ts"
export * from "./QnImage.vue?vue&type=script&lang=ts"
import style0 from "./QnImage.vue?vue&type=style&index=0&id=1ebe506a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebe506a",
  null
  
)

export default component.exports